import React, { useState } from "react";
import { useParams } from "react-router-dom";
import Viewer from "react-viewer";
import Loader from "../../../components/Loader";
import InnerBannerBreadcrumb from "../../../components/shared/breadcrumb/InnerBannerBreadcrumb";
import { useSelector } from "react-redux";
import { useGetApiQuery } from "../../../redux/services/apiHome";
import PageLastUpdated from "../../../components/shared/PageLastUpdated";
import { useLanguageTranslation } from "../../../hooks/useLanguageTranslation";

function SwachhBharatGalleryById() {
  const { languageType } = useSelector((state) => state.homeSlice);
  const { getText } = useLanguageTranslation();
  const { id } = useParams();
  const { data: swachhGallery, isLoading: swachhGalleryIsloading } =
    useGetApiQuery({
      url: "swachh-bharat-abhiyan",
      lang: languageType,
    });

  const swachhGalleryObj = swachhGallery?.data?.find(
    (photo) => photo.id === id
  );

  console.log(swachhGalleryObj);

  const [visible, setVisible] = React.useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const [currentImages, setCurrentImages] = useState([]);

  // const lastUpdatedOn = useMemo(() => {
  //   return extractDate(swachhGalleryObj);
  // }, [swachhGalleryObj]);

  const openViewer = (images, index) => {
    setCurrentImages(
      images.map((img) => ({
        src: `${process.env.REACT_APP_IMAGE_URL}/${img.image_url}`,
        alt: img.image_descriptions,
      }))
    );
    setActiveIndex(index);
    setVisible(true);
  };

  if (swachhGalleryIsloading) {
    return <Loader />;
  }

  return (
    <>
      <InnerBannerBreadcrumb
        bannerImage="images/inner_aboutbann.jpg"
        title={getText("Swachh Bharat Abhiyan", "स्वच्छ भारत अभियान")}
        titleLink="/sustainable-development/swachh-bharat-abhiyan"
        titleTwo={swachhGalleryObj?.title}
        levelTwo={true}
        levelThree={false}
        isActive={swachhGalleryObj?.title}
      />
      <div className="inner-container">
        <div className="container">
          <section className="ourCompany">
            <div className="container">
              <PageLastUpdated
                lastUpdatedOn={swachhGallery?.data[0]?.changed}
              />

              <div className="row mb-5">
                {swachhGalleryObj?.field_events_image?.map((item, index) => (
                  <div className="col-12 col-sm-12 col-md-3 col-lg-3 mb-4">
                    <div
                      className="card-sec wow zoomIn"
                      style={{ visibility: "visible", animationName: "zoomIn" }}
                      onClick={() => {
                        openViewer(swachhGalleryObj?.field_events_image, index);
                      }}
                    >
                      <div className="img-sec">
                        <img
                          src={`${process.env.REACT_APP_IMAGE_URL}/${item.image_url}`}
                          alt={item.image_descriptions}
                          width={100}
                        />
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>
        </div>
      </div>
      <Viewer
        visible={visible}
        onClose={() => setVisible(false)}
        onMaskClick={() => setVisible(false)}
        images={currentImages}
        activeIndex={activeIndex}
        rotatable={false}
        zoomable={true}
        scalable={false}
        drag={false}
      />
    </>
  );
}

export default SwachhBharatGalleryById;
